import { render, staticRenderFns } from "./PersonNewsListItem.vue?vue&type=template&id=d6152b7e&scoped=true"
import script from "./PersonNewsListItem.vue?vue&type=script&lang=js"
export * from "./PersonNewsListItem.vue?vue&type=script&lang=js"
import style0 from "./PersonNewsListItem.vue?vue&type=style&index=0&id=d6152b7e&prod&lang=scss&scoped=true"
import style1 from "./PersonNewsListItem.vue?vue&type=style&index=1&id=d6152b7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6152b7e",
  null
  
)

export default component.exports